'use strict';

module.exports = function(angularModule) {
  angularModule.service('RGSenderConfigService', function($http, $q) {

    let savedConfig = null;

    this.getConfig = function() {
      if (savedConfig !== null) {
        return $q.when(_.clone(savedConfig));
      }
      return $http.get("/reviewBuilder/config").then(function(response) {
        savedConfig = response.data;
        return _.clone(response.data);
      })
    };


    this.getConfigForCampaign = function(campaignId) {
      return $http.get("/reviewBuilder/config/" + campaignId).then(function(response) {
        return _.clone(response.data);
      })
    }

    this.updateEmailConfig = function(email, senderName) {
      return $http.put("/reviewBuilder/config/email", {emailAddress: email, senderName: senderName}).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      });
    };

    this.refreshConfig = function(customEmailId) {
      return $http.post("/reviewBuilder/config/email/refresh/" + customEmailId).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      });
    }

    this.markCustomEmailAsDefault = function(customEmailId) {
      return $http.post("/reviewBuilder/config/email/default", {customEmailId: customEmailId}).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      });
    }

    this.deleteCustomEmail = function(customEmailId) {
      return $http.post("/reviewBuilder/config/email/delete/" + customEmailId).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      });
    }

    this.updateDefaultSenderName = function(senderName) {
      return $http.post("/reviewBuilder/config/email/updateDefaultSenderName", {updatedSenderName:senderName}).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      })
    }

    this.addCustomEmailSender = function(fromAddress, senderName) {
      return $http.post("/reviewBuilder/config/email/add",
        {fromAddress:fromAddress, senderName: senderName}).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      })
    }

    this.updateCustomEmailSenderName = function(customEmailId, senderName) {
      return $http.post("/reviewBuilder/config/email/" + customEmailId + "/updateSenderName",
        {updatedSenderName:senderName}).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      })
    }

    this.updateSecurity = function(config) {
      return $http.post("/reviewBuilder/config/security", config).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      })
    }

    this.updateEmailSettings = function(privacyPolicyUrl, hideLocationText, customFooter) {
      return $http.post("/reviewBuilder/config/emailSettings", { privacyPolicyUrl, hideLocationText, customFooter }).then(function(response){
        savedConfig = response.data;
        return _.clone(savedConfig);
      });
    }

    this.updateMessageWarningConfig = function(warningThreshold, sendEmailNotifications) {
      return $http.post("/reviewBuilder/messageQuotaConfig", {warningThreshold: warningThreshold,
        sendEmailNotifications: sendEmailNotifications}).then(function(response) {
        savedConfig = response.data;
        return _.clone(savedConfig);
      });
    };

  });
};
